/**
 * Utility to prevent zoom on mobile devices while preserving scrolling
 * Follows "Designing Data-Intensive Applications" reliability principles
 */

let lastTouchEnd = 0;

export const preventZoom = () => {
  // Prevent double-tap zoom
  document.addEventListener('touchend', function (event) {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent pinch zoom
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchmove', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });

  // Prevent zoom via wheel events (for trackpad/mouse wheel on desktop)
  document.addEventListener('wheel', function (event) {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  }, { passive: false });

  // Prevent keyboard zoom (Ctrl +/-)
  document.addEventListener('keydown', function (event) {
    if ((event.ctrlKey || event.metaKey) && 
        (event.keyCode === 61 || event.keyCode === 107 || 
         event.keyCode === 173 || event.keyCode === 109 || 
         event.keyCode === 187 || event.keyCode === 189)) {
      event.preventDefault();
    }
  });
};

// Clean initialization
export const initializeZoomPrevention = () => {
  if (typeof window !== 'undefined') {
    // Only run once
    if (!window.__zoomPreventionInitialized) {
      preventZoom();
      window.__zoomPreventionInitialized = true;
    }
  }
}; 